import { node } from "~/util/dom";
import ReportFormField from "./index";
import { ICommonOpts } from "~/report/interfaces";

interface IOpts extends ICommonOpts {
	text: string;
	onChange: (isOn: boolean, data: object) => void;
	onClick?: () => void;
}

export default class ReportFormFieldButton extends ReportFormField {
	#opts: IOpts;

	#buttonNode: HTMLButtonElement;

	#isOn: boolean;

	constructor(opts: IOpts) {
		super(opts);
		this.#opts = {
			text: "",
			icon: null,
			onChange: () => { /**/ },
			onClick: () => { /**/ },
			...opts,
		};
		this.#isOn = false;

		this.#build();
	}

	handleEvent(event) {
		if (event.type === "click") {
			this.#opts.onClick();
			this.#toggle();
		}
	}

	disable() {
		this.#buttonNode.setAttribute("disabled", "");
	}

	enable() {
		this.#buttonNode.removeAttribute("disabled");
	}

	#toggle() {
		this.#isOn = !this.#isOn;
		if (this.#isOn) {
			this.#buttonNode.classList.add("active");
		} else {
			this.#buttonNode.classList.remove("active");
		}
		this.#opts.onChange(this.#isOn, null);
	}

	#build() {
		const { text, icon } = this.#opts;

		this.#buttonNode = node("button", { className: "form-button" });
		const textNode = node("span", { className: "button-text", innerText: text });

		this.#buttonNode.append(textNode, icon);
		this.#buttonNode.addEventListener("click", this);
		this.#buttonNode.setAttribute("data-log-ignore", "true");

		super.container.append(this.#buttonNode);
	}
}
